/* ============================================================
   Salty Seats - 2026 collection page

   Filtering, sorting, the filler tiles and add to cart. Everything
   is client side over the products already in the DOM, which is what
   makes the chips feel instant. Collections here are small; the
   section warns in the theme editor if one outgrows that.
   ============================================================ */
(function () {
  'use strict';

  function norm(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function money(cents, format) {
    var n = (cents / 100).toFixed(2);
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, n);
  }

  /* ============================================================
     Grid
     ============================================================ */

  function initGrid(root) {
    var grid = root.querySelector('[data-sscoll-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-sscoll-card]'));
    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-sscoll-tile]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-sscoll-filter]'));
    var sorts = Array.prototype.slice.call(root.querySelectorAll('[data-sscoll-sort]'));
    var countEl = root.querySelector('[data-sscoll-count]');
    var moreWrap = root.querySelector('[data-sscoll-more]');
    var moreBtn = root.querySelector('[data-sscoll-more-btn]');
    var emptyEl = root.querySelector('[data-sscoll-empty]');
    var filterRow = root.querySelector('[data-sscoll-filters]');

    var step = parseInt(grid.getAttribute('data-initial'), 10) || 12;
    var state = { filter: 'all', sort: grid.getAttribute('data-default-sort') || 'featured', shown: step };

    /* Best-selling order comes from actual sales, so it is not in this
       page. It is fetched once from the collection under Shopify's own
       best-selling sort and cached, which is what lets the chip reorder
       without a navigation. Until it lands, best falls back to the
       order the server sent. */
    var bestRank = null;
    var bestPending = null;

    function loadBest() {
      if (bestRank || bestPending) return bestPending || Promise.resolve();
      var url = grid.getAttribute('data-url');
      if (!url) return Promise.resolve();
      bestPending = fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'sort_by=best-selling', {
        headers: { Accept: 'text/html' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('sort fetch failed');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var order = doc.querySelectorAll('[data-sscoll-card]');
          if (!order.length) throw new Error('no cards in response');
          var map = {};
          Array.prototype.forEach.call(order, function (el, i) {
            var h = el.getAttribute('data-handle');
            if (h) map[h] = i;
          });
          bestRank = map;
        })
        .catch(function () {
          /* Leave bestRank null: best simply behaves as the server
             order rather than the chip appearing broken. */
          bestRank = {};
        });
      return bestPending;
    }

    /* The filter row only earns its place when something in this
       collection actually carries a colour. */
    if (filterRow) {
      var anyColour = cards.some(function (c) { return c.getAttribute('data-colour'); });
      filterRow.hidden = !anyColour;
    }

    /* A card lists every colour it comes in, so the filter matches on
       membership rather than equality. */
    function matching() {
      return cards.filter(function (c) {
        if (state.filter === 'all') return true;
        var list = norm(c.getAttribute('data-colour')).split(/\s+/);
        return list.indexOf(state.filter) !== -1;
      });
    }

    function domIndex(el) {
      return parseInt(el.getAttribute('data-index'), 10) || 0;
    }

    function sorted(list) {
      var out = list.slice();
      if (state.sort === 'low' || state.sort === 'high') {
        out.sort(function (a, b) {
          var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
          var pb = parseInt(b.getAttribute('data-price'), 10) || 0;
          return state.sort === 'low' ? pa - pb : pb - pa;
        });
      } else if (state.sort === 'best' && bestRank) {
        /* Anything the best-selling response did not mention keeps its
           server position, after everything that did. */
        out.sort(function (a, b) {
          var ra = bestRank[a.getAttribute('data-handle')];
          var rb = bestRank[b.getAttribute('data-handle')];
          if (ra == null && rb == null) return domIndex(a) - domIndex(b);
          if (ra == null) return 1;
          if (rb == null) return -1;
          return ra - rb;
        });
      } else {
        out.sort(function (a, b) {
          return (parseInt(a.getAttribute('data-index'), 10) || 0)
            - (parseInt(b.getAttribute('data-index'), 10) || 0);
        });
      }
      return out;
    }

    function columns() {
      if (window.matchMedia('(max-width: 749px)').matches) return 2;
      if (window.matchMedia('(max-width: 1099px)').matches) return 2;
      return 3;
    }

    /* How many filler tiles to drop in. Chosen so the products plus
       the tiles fill whole rows - a ragged last row is the thing the
       design is avoiding here, not the tiles themselves. */
    function tileCount(n, cols) {
      for (var k = Math.min(2, tiles.length); k >= 0; k--) {
        if ((n + k) % cols === 0) return k;
      }
      return 0;
    }

    function render() {
      var list = sorted(matching());
      var n = list.length;
      var cols = columns();
      var t = n > 0 ? tileCount(n, cols) : 0;
      var total = n + t;

      /* Slots are distinct by construction for t of 1 or 2. */
      var cells = new Array(total);
      for (var j = 0; j < t; j++) {
        var slot = Math.floor((j + 1) * total / (t + 1));
        if (slot > total - 1) slot = total - 1;
        if (slot < 0) slot = 0;
        cells[slot] = tiles[j];
      }
      var pi = 0;
      for (var i = 0; i < total; i++) {
        if (!cells[i]) cells[i] = list[pi++];
      }

      cards.forEach(function (c) { c.hidden = true; });
      tiles.forEach(function (c) { c.hidden = true; });

      cells.forEach(function (el, idx) {
        if (!el) return;
        if (idx >= state.shown) return;
        el.hidden = false;
        el.style.order = String(idx);
      });

      if (countEl) {
        countEl.textContent = n + (n === 1 ? ' product' : ' products');
      }
      if (emptyEl) emptyEl.hidden = n !== 0;
      if (moreWrap) moreWrap.hidden = total <= state.shown;

      filters.forEach(function (b) {
        b.setAttribute('aria-pressed', norm(b.getAttribute('data-value')) === state.filter ? 'true' : 'false');
      });
      sorts.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-value') === state.sort ? 'true' : 'false');
      });
    }

    filters.forEach(function (b) {
      b.addEventListener('click', function () {
        state.filter = norm(b.getAttribute('data-value'));
        state.shown = step;
        render();
      });
    });

    sorts.forEach(function (b) {
      b.addEventListener('click', function () {
        state.sort = b.getAttribute('data-value');
        render();
        if (state.sort === 'best' && !bestRank) loadBest().then(render);
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.shown += step;
        render();
      });
    }

    /* The tile placement depends on the column count, so it has to be
       recomputed when the grid changes shape. */
    var wide = window.matchMedia('(max-width: 1099px)');
    if (wide.addEventListener) wide.addEventListener('change', render);
    else if (wide.addListener) wide.addListener(render);

    render();
    initAddToCart(root);

    /* Fetched up front rather than on first click, so that by the time
       anyone reaches the toolbar the order is already here and the
       chip does not have to wait on the network. */
    if (state.sort === 'best' || sorts.some(function (b) { return b.getAttribute('data-value') === 'best'; })) {
      loadBest().then(render);
    }
  }

  /* ============================================================
     Add to cart
     ============================================================ */

  function initAddToCart(root) {
    root.querySelectorAll('[data-sscoll-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant');
        if (!id) return;
        if (btn.getAttribute('aria-busy') === 'true') return;

        var original = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = btn.getAttribute('data-adding') || 'Adding';

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            btn.textContent = btn.getAttribute('data-added') || 'Added';
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {} }));
            setTimeout(function () {
              btn.textContent = original;
              btn.removeAttribute('aria-busy');
            }, 1600);
          })
          .catch(function () {
            btn.textContent = btn.getAttribute('data-failed') || 'Try again';
            setTimeout(function () {
              btn.textContent = original;
              btn.removeAttribute('aria-busy');
            }, 2000);
          });
      });
    });
  }

    function initFaq(root) {
    root.querySelectorAll('[data-sscoll-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.sscoll-faq__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var mark = btn.querySelector('[data-sscoll-faq-mark]');
        if (mark) mark.textContent = open ? '−' : '+';
      });
    });
  }

  /* ============================================================
     Boot
     ============================================================ */

  function init(root) {
    if (!root || root.dataset.sscollInit === '1') return;
    root.dataset.sscollInit = '1';
    if (root.querySelector('[data-sscoll-grid]')) initGrid(root);
    if (root.querySelector('[data-sscoll-faq]')) initFaq(root);
  }

  function boot() {
    document.querySelectorAll('.sscoll').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-initialise when the theme editor swaps a section in. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.sscoll').forEach(init);
  });
})();
